// dependencies imports ⇒
import React, { useState } from "react";
// assets and scss imports ⇒
import "./paymentSummary.scss";
import { getPaidAmountRefund, getValueUpto2DecimalPlaces } from "../helper";
import Popover from "react-popover";
import info_icon from "../../../assets/dashboard/info_icon.svg";

const PaymentSummary = (props) => {
  const {
    appointmentDetails,
    totalRefund,
    discountAtClinic,
    inputValue,
    totalFees,
    totalConsultationFees,
    totalPendingAmount,
    totalAmountPaid,
    hasPartialAmount,
    totalPaidPartialAmount,
    totalGST,
    totalConvenience,
    totalPaidFullAmount,
    totalPartialAmountWithoutConvenience,
    totalCustomGst,
  } = props;

  const [isOpen, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  // Helper Methods ===>

  const calculateTotalOnlinePayedAmount = (appointments) => {
    let totalOnlinePayedAmountList = appointments?.filter(
      (data) =>
        data.partial_amount == 0 &&
        data.payment_method !== "Paid at Clinic - By Cash"
    );
    let totalOnlinePayedAmount = 0;
    if (totalOnlinePayedAmountList?.length > 0) {
      totalOnlinePayedAmount = totalOnlinePayedAmountList.reduce(
        (a, v) => a + v.consultation_fee_in_rupees,
        0
      );
      let totalDiscount = totalOnlinePayedAmountList.reduce(
        (a, v) => a + v.discount_on_consultation_fee_in_rupees,
        0
      );
      totalOnlinePayedAmount = totalOnlinePayedAmount - totalDiscount;
    }
    return totalOnlinePayedAmount;
  };

  const calculateTotalPartialAndFullAmount = (fullOnlineAmont) => {
    let onlinePaidGst = appointmentDetails.reduce(
      (a, v) =>
        a +
        (v?.partial_amount == 0 && v?.payment_method?.toLowerCase() === "online"
          ? Number(v.custom_gst_in_rupees)
          : 0),
      0
    );
    return (
      Number(fullOnlineAmont) +
      Number(totalPartialAmountWithoutConvenience) +
      Number(totalConvenience) +
      Number(totalGST) +
      getValueUpto2DecimalPlaces(Number(onlinePaidGst))
    );
  };

  const getFullOnlinePaidGST = (original_appointments) => {
    let onlinePaidGst = original_appointments.reduce(
      (a, v) =>
        a +
        (v?.partial_amount == 0 && v?.payment_method?.toLowerCase() === "online"
          ? Number(v.custom_gst_in_rupees)
          : 0),
      0
    );

    return getValueUpto2DecimalPlaces(onlinePaidGst);
  };

  // <===

  // create UI ⇒

  const displayAmountPaidDetails = () => {
    let refundAmount = getPaidAmountRefund(
      totalAmountPaid,
      totalFees,
      totalPaidPartialAmount,
      appointmentDetails
    );

    return (
      <>
        {totalAmountPaid > 0 && (
          <div id="accordion" className="accordion">
            <div className="card-container">
              <div
                className="card-header"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapseThree"
              >
                <span className="circle_plus_minus"></span>
                <a className="card-title">
                  <span className="card_title_name">
                    Amount Paid (Paid at Clinic)
                  </span>
                  <span>
                    <span>₹</span>
                    {parseFloat(
                      (
                        totalAmountPaid - (refundAmount > 0 ? refundAmount : 0)
                      )?.toFixed(2)
                    )}
                  </span>
                </a>
              </div>
              <div
                id="collapseThree"
                className="card-body collapse"
                data-parent="#accordion"
              >
                <div className="partial-convenience-gst-container">
                  <div className="partial-convenience-gst-wrapper">
                    <div className="fee-type-wrappper">
                      <div className="amount-title">Paid Amount</div>
                      <div className="amount-number">
                        <span>₹</span>
                        {parseFloat(totalAmountPaid?.toFixed(2)) ?? 0}
                      </div>
                    </div>
                    {refundAmount > 0 && (
                      <div className="payment-summary-details-row refund">
                        <div className="payment-summary-details-heading">
                          Refund
                        </div>
                        <p>
                          <span>-₹</span>
                          {refundAmount}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const displayAmountToBePaidDetails = () => {
    return (
      <>
        {totalPendingAmount > 0 && (
          <div id="accordion" className="accordion">
            <div className="card-container">
              <div
                className="card-header"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapseTwo"
              >
                <span className="circle_plus_minus"></span>
                <a className="card-title">
                  <span className="card_title_name">
                    Amount To Be Paid (Pay at Clinic)
                  </span>
                  <span>
                    <span>₹</span>
                    {parseFloat(totalPendingAmount?.toFixed(2))}
                  </span>
                </a>
              </div>
              <div
                id="collapseTwo"
                className="card-body collapse"
                data-parent="#accordion"
              >
                <div className="partial-convenience-gst-container">
                  <div className="partial-convenience-gst-wrapper">
                    <div className="fee-type-wrappper">
                      <div className="amount-title">Pending Amount</div>
                      <div className="amount-number">
                        <span>₹</span>
                        {parseFloat(totalPendingAmount?.toFixed(2)) ?? 0}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const displayOnlinePaidAmountDetails = () => {
    let appointmentWithFullyPaidOnlieAmount =
      calculateTotalOnlinePayedAmount(appointmentDetails);
    let appointmentWithPartialAndFullOnlineAmount =
      calculateTotalPartialAndFullAmount(appointmentWithFullyPaidOnlieAmount);
    let fullOnlinePaidGST = getFullOnlinePaidGST(appointmentDetails);
    let consultationFeesWithGST = getValueUpto2DecimalPlaces(
      appointmentWithFullyPaidOnlieAmount + fullOnlinePaidGST
    );
    const infoText = "Including GST";

    return (
      <>
        {(hasPartialAmount ||
          +appointmentWithFullyPaidOnlieAmount > 0 ||
          +totalPartialAmountWithoutConvenience > 0) && (
          <div id="accordion" className="accordion">
            <div className="card-container">
              <div
                className="card-header"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapseOne"
              >
                <span className="circle_plus_minus"></span>
                <a className="card-title">
                  <span className="card_title_name">Amount Paid (Online)</span>
                  <span>
                    <span>₹</span>
                    {getValueUpto2DecimalPlaces(
                      appointmentWithPartialAndFullOnlineAmount
                    )}
                  </span>
                </a>
              </div>
              <div
                id="collapseOne"
                className={"card-body collapse"}
                data-parent="#accordion"
              >
                <div className="partial-convenience-gst-container">
                  <div className="partial-convenience-gst-wrapper">
                    {+totalPartialAmountWithoutConvenience > 0 && (
                      <div className="fee-type-wrappper">
                        <div className="amount-title">Partial Amount</div>
                        <div className="amount-number">
                          <span>₹</span>
                          {getValueUpto2DecimalPlaces(
                            totalPartialAmountWithoutConvenience
                          )}
                        </div>
                      </div>
                    )}

                    {+consultationFeesWithGST > 0 && (
                      <div className="fee-type-wrappper">
                        <div className="amount-title">
                          Consultation Fee{" "}
                          {fullOnlinePaidGST > 0 && displayInfo(infoText)}
                        </div>
                        <div className="amount-number">
                          <span>₹</span>
                          {getValueUpto2DecimalPlaces(consultationFeesWithGST)}
                        </div>
                      </div>
                    )}

                    <div className="fee-type-wrappper">
                      <div className="amount-title">Convenience Fee</div>
                      <div className="amount-number">
                        <span>₹</span>
                        {totalConvenience == null ? 0 : totalConvenience}
                      </div>
                    </div>
                    <div className="fee-type-wrappper">
                      <div className="amount-title">GST</div>
                      <div className="amount-number">
                        <span>₹</span>
                        {totalGST == null ? 0 : totalGST}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const totalFee = () => {
    return (
      <div className="total-fee-container">
        <div className="total-fee-heading-wrapper">
          <p className="total-fee-heading">Total fee</p>
          <p className="total-fee-amount">
            <span>₹</span>
            {totalFees ?? 0}
          </p>
        </div>
        {displayOnlinePaidAmountDetails()}
        {displayAmountPaidDetails()}
        {displayAmountToBePaidDetails()}
      </div>
    );
  };

  const paymentSummaryUI = () => {
    return (
      <div className="payment-summary-container">
        <div className="payment-summary-heading">Payment Summary</div>
        <div className="payment-summary-details-container">
          <div className="payment-summary-details-wrapper">
            <div className="payment-summary-details-row">
              <div className="payment-summary-details-heading">
                Consultation Fee
              </div>
              <p>
                <span>₹</span>
                {totalConsultationFees}
              </p>
            </div>
            {+inputValue !== 0 &&
              parseFloat(discountAtClinic?.toFixed(2)) !== 0 && (
                <div className="payment-summary-details-row discount">
                  <div className="payment-summary-details-heading">
                    Discount
                  </div>
                  <p>
                    <span>-₹</span>
                    {parseFloat(discountAtClinic?.toFixed(2))}
                  </p>
                </div>
              )}
            {+totalRefund !== 0 && (
              <div className="payment-summary-details-row refund">
                <div className="payment-summary-details-heading">Refund</div>
                <p>
                  <span>-₹</span>
                  {totalRefund}
                </p>
              </div>
            )}
            {+totalCustomGst !== 0 && (
              <div className="payment-summary-details-row">
                <div className="payment-summary-details-heading">GST</div>
                <p>
                  <span>₹</span>
                  {getValueUpto2DecimalPlaces(+totalCustomGst)}
                </p>
              </div>
            )}
          </div>
          <div className="dashed-border"> </div>
          {totalFee()}
        </div>
      </div>
    );
  };

  const displayInfo = (info) => {
    return (
      <Popover
        isOpen={isOpen}
        preferPlace={`below`}
        place={null}
        anchorEl={anchorEl}
        body={displayHoverContent(info)}
      >
        <img
          src={info_icon}
          alt=""
          style={{ cursor: "pointer", marginLeft: "5px" }}
          onMouseOver={handlePopoverOpen}
          onMouseOut={handlePopoverClose}
        />
      </Popover>
    );
  };

  const displayHoverContent = (infoText) => {
    return (
      <div
        style={{
          padding: "6px 10px",
          fontSize: "12px",
          width: "100%",
          textAlign: "center",
        }}
      >
        {infoText}
      </div>
    );
  };

  return <>{paymentSummaryUI()}</>;
};

//export
export default PaymentSummary;
